<template>
  <div class="goods-detail">
    <div class="app-body" :class="{'is-loading':loading}" ref="body">
      <van-skeleton
        title
        title-width="100%"
        :row="8"
        :loading="loading"
      >
        <div class="goods">
          <van-sticky>
            <div class="goods-headicon-box">
              <div class="goods-headicon back" @click="goBack">
                <van-icon name="arrow-left" />
              </div>
              <!-- <div class="goods-headicon cart" @click="onClickCart">
                <van-icon name="cart-o" info="3" />
              </div> -->
              <!-- <div class="goods-headicon share">
                <van-icon name="share" />
              </div> -->
              <!-- <div class="goods-headicon tags" @click="toImage">
                <van-icon name="share" />分享有礼
              </div> -->
            </div>
          </van-sticky>
          <van-swipe class="goods-swipe" :autoplay="3000" :style="imageStyle">
            <van-swipe-item>
              <van-image
                fit="cover"
                lazy-load
                :src="rootPath + goods.img"
              />
            </van-swipe-item>
          </van-swipe>

          <van-cell-group>
            <van-cell>
              <van-sticky class="sticky-title">
                <div class="goods-title">{{ goods.name }}</div>
              </van-sticky>
              <div v-if="goods.tags" class="goods-tags">
                <van-tag v-for="(tag, index) in (goods.tags ? goods.tags.split(',') : [])" :key="index" type="primary">{{ tag }}</van-tag>
              </div>
            </van-cell>
            <van-cell class="goods-express">
              <div class="prices">
                <div class="goods-price">
                  <small v-if="!isbook">免费</small>
                  <div v-if="isbook">
                    <small>售价：</small> <small>¥</small>{{ formatPrice(goods.price) }}
                    <div class="goods-market">
                      <span v-if="goods.market"><small>¥</small> {{ formatPrice(goods.market) }}</span>
                    </div>
                  </div>
                </div>
                <div span="6" class="text-right">
                  {{ isbook ? '销量' : '报名' }}：{{ goods.sales }}
                </div>
              </div>
            </van-cell>
          </van-cell-group>

          <!-- 优惠券单元格 -->
          <van-cell v-if="couponList && couponList.length" :value="couponsValue" is-link @click="showList = true" class="goods-coupon">
            <!-- 使用 title 插槽来自定义标题 -->
            <template slot="title">
              <van-tag color="#ffe1e1" text-color="#ad0000"><van-icon name="coupon-o" /> <span class="tag">优惠券</span></van-tag>
            </template>
          </van-cell>

          <!-- 优惠券列表 -->
          <van-popup v-model="showList" position="bottom">
            <van-coupon-list
              :coupons="coupons"
              :chosen-coupon="chosenCoupon"
              :disabled-coupons="disabledCoupons"
              @change="onChange"
              @exchange="onExchange"
            />
          </van-popup>

          <van-cell-group v-if="!isbook && goods.address" class="goods-cell-group contents" title="">
            <div class="goods-contents">
              <h3>活动地址</h3>
              <div class="goods-content icons"><van-icon name="location-o" />{{ goods.address }}</div>
            </div>
          </van-cell-group>

          <van-cell-group v-if="!isbook && goods.zjr" class="goods-cell-group contents" title="">
            <div class="goods-contents">
              <h3>主讲人</h3>
              <div class="goods-content icons"><van-icon name="user-o" />{{ goods.zjr }}</div>
            </div>
          </van-cell-group>

          <van-cell-group v-if="goods.isbm" class="goods-cell-group contents">
            <div class="goods-contents">
              <h3>{{ goods.title2 || '报名须知' }}</h3>
              <div class="goods-content" v-html="goods.content2"></div>
            </div>
          </van-cell-group>
          
          <van-cell-group class="goods-cell-group contents" ref="contents">
            <div class="goods-contents">
              <h3>{{ isbook ? '商品详情' : '活动详情' }}</h3>
              <div class="goods-content" v-html="goods.content"></div>
            </div>
          </van-cell-group>

          <van-goods-action>
            <van-goods-action-icon icon="home-o" icon-class="home" @click="goHome">
              首页
            </van-goods-action-icon>
            <van-goods-action-icon icon="arrow-left" :to="'/kp/'+ goods.navname">
              返回
            </van-goods-action-icon>
            <!-- <van-goods-action-icon icon="chat-o" @click="sorry">
              客服
            </van-goods-action-icon> -->
            <!-- <van-goods-action-icon icon="cart-o" info="3" @click="onClickCart">
              购物车
            </van-goods-action-icon> -->
            <!-- <van-goods-action-button type="warning" @click="sorry">
              加入购物车
            </van-goods-action-button> -->
            <van-goods-action-button :color="goods.isup ? 'linear-gradient(to right, #40baff, #3b8dd1)' : 'linear-gradient(to right, #eee, #ccc)'" class="btn-buy" @click="goBuy(null)">
              {{ isbook ? (goods.isup ? '立即购买' : '已下架') : (goods.isup ? '立即报名' : '未开始') }}
            </van-goods-action-button>
          </van-goods-action>
        </div>
      </van-skeleton>
    </div>

    <!-- :sku="sku" -->
    <van-sku
      v-model="skushow"
      stepper-title="购买数量"
      :sku="sku"
      show-add-cart-btn
      reset-stepper-on-hide
      @buy-clicked="onBuyClicked"
      @add-cart="onClickCart"
    >
      <!-- 自定义 sku-header-price -->
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__goods-info">
            <div class="van-sku-price-box">
              <div class="van-sku__goods-title">{{ goods.name }}</div>
              
            </div>
            <!-- <div class="van-sku-header-item">已选 天蓝色；2</div>
            <i class="van-icon van-icon-clear van-sku__close-icon"></i> -->
          </div>
          <!-- <i class="van-icon van-icon-cross van-sku__close-icon" @click="skushow = false"></i> -->
        </div>
        <div class="van-sku__steppers">
          <div class="van-sku__goods-price">
            <span v-if="goods.price" class="van-sku__price-num"><small class="van-sku__price-symbol">￥</small>{{ goods.price }}</span>
            <span v-if="!goods.price">数量</span>
          </div>
          <div class="times"><van-icon name="cross" /></div>
          <van-stepper v-model="sales" />
        </div>
      </template>

      <!-- 自定义 sku-header-price -->
      <!-- <template slot="sku-header-price" slot-scope="props">
        <div class="van-sku__goods-price">
          <span class="van-sku__price-symbol">￥</span><span class="van-sku__price-num">{{ props.price }}</span>
        </div>
      </template> -->

      <!-- 自定义 sku-stepper -->
      <template slot="sku-stepper" slot-scope="props">
        <div></div>
      </template>

      <!-- 自定义 sku-header-messages -->
      <template slot="sku-messages" slot-scope="props">
        <div class="van-sku-messages">
          <van-cell-group title="联系信息">
            <van-field
              v-model="users.name"
              required
              clearable
              left-icon="contact"
              label="姓名"
              placeholder="请输入姓名"
              :error="users.name_rule.error"
              :error-message="errMsg('name')"
              @blur="validate('name')"
              ref="name"
            />
            <van-field
              v-model="users.sfzh"
              required
              clearable
              left-icon="idcard"
              label="身份证号"
              placeholder="请输入身份证号"
              :error="users.sfzh_rule.error"
              :error-message="errMsg('sfzh')"
              @blur="validate('sfzh')"
              ref="sfzh"
            />
            <van-field
              v-model="users.mobile"
              required
              clearable
              left-icon="phone-o"
              label="手机号"
              placeholder="请输入手机号"
              :error="users.mobile_rule.error"
              :error-message="errMsg('mobile')"
              @blur="validate('mobile')"
              ref="mobile"
            >
            </van-field>
            <!-- <van-field
              v-model="users.captcha"
              required
              clearable
              left-icon="passed"
              label="验证码"
              placeholder="请输入验证码"
              :error="users.captcha_rule.error"
              :error-message="errMsg('captcha')"
              @blur="validate('captcha')"
              ref="captcha"
            >
              <van-button slot="button" size="small" type="primary" :disabled="captcha.issend" :loading="captcha.loading" @click="sendCaptcha">
                <van-count-down
                  v-if="captcha.issend"
                  :time="captcha.time"
                  format="ss"
                  @finish="enabledCaptcha"
                />
                <span v-else>发送验证码</span>
              </van-button>
            </van-field> -->
            <van-field
              v-model="note"
              label="备注"
              clearable
              type="textarea"
              left-icon="edit"
              placeholder="其他特别说明"
              rows="1"
              autosize
            />
          </van-cell-group>
        </div>
      </template>

      <!-- 自定义 sku actions -->
      <template slot="sku-actions" slot-scope="props">
        <!-- <van-notice-bar
          left-icon="info-o"
          wrapable
        >
          此为定制套餐，无正当理由不可退改，如7天内因个人原因退款，需扣除20%手续费。
        </van-notice-bar> -->
        <div class="van-sku-actions">
          <!-- <van-button
            square
            size="large"
            type="warning"
            @click="onPointClicked"
          >
            积分兑换
          </van-button> -->
          <div v-if="goods.price" class="van-sku-subtotal">
            小计：<span class="prices"><small>¥</small>{{ formatPrice(amount) }}</span>
          </div>
          <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
          <van-button
            square
            size="large"
            type="danger"
            @click="goPay(props)"
          >
            {{ isbook ? '微信支付' : '立即报名' }}
          </van-button>
        </div>
      </template>
    </van-sku>

    <!-- 分享海报 begin -->
    <!-- <van-dialog
      v-model="isok"
      title="分享海报"
      show-cancel-button
    > -->
      <div class="poster" ref="imageWrapper">
        <div class="poster-head">
          <div class="poster-note">我发现了这个超级好东西，一起分享</div>
          <div class="poster-author">
            @ 旅朋友
          </div>
        </div>
        <div class="poster-body" :style="imageStyle2">
          <div
            class="poster-img"
            :style="{'background-image':'url('+ rootPath + goods.img +')'}"
          >
          </div>
          <!-- <div class="poster-features1">
            {{ goods.features }}
          </div> -->
        </div>
        <div class="poster-footer">
          <div class="poster-infos">
            <div class="poster-title">{{ goods.name }}</div>
            <div class="poster-features">
              {{ goods.features }}
            </div>
            <div class="poster-price"><small>¥</small>{{ formatPrice(goods.price) }}
              <div class="poster-market">市场价 <small>¥</small>{{ formatPrice(goods.market) }}</div>
            </div>
          </div>
          <div v-if="qrcodeUrl" class="poster-qrcode" ref="qrcode">
            <img :src="qrcodeUrl" >
            <div class="logo">
              <img :src="assetsPath +'static/images/logo.png'">
            </div>
          </div>
        </div>
      </div>
    <!-- </van-dialog> -->
    <van-dialog
      v-model="showPoster"
      :show-confirm-button="false"
      class="poster-dialog"
    >
      <!-- <img src="https://img.yzcdn.cn/vant/apple-3.jpg"> -->
      <i class="van-icon van-icon-cross poster-close" @click="showPoster = false"></i>
      <img class="real_pic" :src="dataURL" />
      <div class="poster-btns">
        <van-button round type="danger" size="small">分享给朋友</van-button>
        <van-button round type="primary" size="small" @click="savePoster">{{ isWeixin ? '长按图片保存' : '保存图片' }}</van-button>
      </div>
    </van-dialog>
    <!-- 分享海报 end -->
    <!--  -->
  </div>
</template>
<script>
const coupon = {
  available: 1,
  condition: '无使用门槛\n最多优惠12元',
  reason: '',
  value: 150,
  name: '优惠券名称',
  startAt: 1489104000,
  endAt: 1514592000,
  valueDesc: '1.5',
  unitDesc: '元'
};
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import QRCode from 'qrcode';
// import html2canvas from 'html2canvas';
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  components: {
  },
  props: {
    id: String,
    skus: String,
    back: String
  },
  data() {
    return {
      loading: false,
      isok: true,
      dataURL: null,
      showPoster: false,
      qrcodeUrl: null,
      skushow: false,
      showList: false,
      chosenCoupon: -1,
      coupons: [coupon],
      disabledCoupons: [coupon],
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        none_sku: true, // 是否无规格商品
        hide_stock: false // 是否隐藏剩余库存
      },
      goods: {},
      couponList: [],
      w: 0,
      users: {
        name: '',
        name_rule: {error:false, required:true, message:'请填写姓名！'},
        mobile: '',
        mobile_rule: {error:false, required:true, pattern:/^1[3456789]\d{9}$/, message:'手机号码不正确！'},
        sfzh: '',
        sfzh_rule: {error:false, required:true, pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          message:'请填写正确的身份证号！'},
        captcha: '',
        captcha_rule: {error:false, required:true, pattern:/^\d{4}$/, message:'请输入正确的验证码！'}
      },
      captcha: {
        loading: false,
        issend: false,
        time: 150
      },
      sales: 1,
      note: '',
      payforward: false
    }
  },
  computed: {
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.818) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {height: (400 * 0.68) + 'px'};
      return style;
    },
    isbook() {
      return this.goods.navname == 'book';
    },
    couponsValue() {
      if (this.chosenCoupon > -1) {
        return '-¥' + this.coupons[this.chosenCoupon].valueDesc;
      } else {
        if (this.coupons.length) {
          return this.coupons.length + '张可用';
        }
        return '无可用券';
      }
    },
    amount() {
      return ((this.goods.price || 0) * this.sales).toFixed(2);
    }
  },
  watch: {
    id() {
      this.getData();
      // this.$nextTick(() => {
      //   this.drawQrcode();
      // });
    },
    member(m) {
      if (m.id) {
        if (!this.users.name) {
          this.users.name = m.name || m.nickname;
        }
        if (!this.users.sfzh) {
          this.users.sfzh = m.sfzh || '';
        }
        if (!this.users.mobile) {
          this.users.mobile = m.mobile || '';
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.payforward) {
      next();
      return;
    }
    if (this.skushow) {
      this.skushow = false;
      next(false);
    } else {
      next();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
    // this.getData();
    // this.getImgW();
  },
  activated() {
    if (!this.goods.id) {
      this.getData();
    }
    if (!this.w) {
      this.getImgW();
    }
    this.$nextTick(() => {
      this.drawQrcode();
    });
    if (this.skus == 'true') {
      this.skushow = true;
    }
  },
  methods: {
    getData() {
      if (!this.id || this.loading) {
        return;
      }
      this.goods = {};
      this.loading = true;
      this.doGet({
        url: 'vue/kp/detail/'+ this.id,
        okcb: (json) => {
          this.goods = Object.assign({}, json || {});
        },
        cb: () => {
          this.$nextTick(() => this.loading = false);
        }
      });
      if (this.member.id) {
        if (!this.users.name) {
          this.users.name = this.member.name || this.member.nickname || '';
        }
        if (!this.users.sfzh) {
          this.users.sfzh = this.member.sfzh || '';
        }
        if (!this.users.mobile) {
          this.users.mobile = this.member.mobile || '';
        }
      }
      this.payforward = false;
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    drawQrcode() {
      this.qrcodeUrl = '';
      let text = this.BASEPATH + '/good/'+ this.id;
      QRCode.toDataURL(text, {margin:1, width:130, height:130, color:{light:'#FFFFFFCC'}})
        .then(url => {
          // console.log(url)
          this.qrcodeUrl = url;
        })
        .catch(err => {
          // console.error(err)
        });
    },
    formatPrice(price) {
      return price;
    },
    goHome() {
      this.$router.push('/');
    },
    goBack() {
      this.$router.push(this.back || '/kp');
    },
    onClickCart() {
      this.$router.push('/cart');
    },
    login() {
      this.payforward = true;
      // 如果是微信浏览器，记住登录后返回地址
      let backUrl = '/kp/detail/'+ this.id +'?skus=true';
      this.doLogin(backUrl);
    },
    goBuy(item) {
      // 如果已下架
      if (!this.goods.isup) {
        return;
      }

      this.skushow = true;
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || (this.isWeixin && !this.member.openid)) {
        setTimeout(() => {
          this.login();
        }, 100);
      }
    },
    // 提交支付
    onBuyClicked() {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || (this.isWeixin && !this.member.openid)) {
        setTimeout(() => {
          this.login();
        }, 100);
      }

      let postData = {
        _member: {id:this.member.id, mobile: this.users.mobile, name: this.users.name, sfzh: this.users.sfzh, captcha: this.users.captcha},
        price: this.goods.price,
        count: this.sales,
        amount: Number(this.amount),
        paymethod:'WX',
        id: this.goods.id,
        note: this.note,
        openid: this.member.openid
        //openid: this.isWeixin ? this.member.openid : null
      }
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'vue/kp/buy',
        data: postData,
        okcb: (json) => {
          this.skushow = false;
          // 如果已报名，则直接跳转到订单详情页
          if (json.isok) {
            this.skushow = false;
            this.$router.push('/order/'+ json.id);
            return;
          }
          // 跳转订单页
          this.$router.push('/kp/order/'+ json.id);

          /**
          // 如果需要公众号openid
          if (json.needopenid) {
            setTimeout(() => {
              this.login();
            }, 100);
            return;
          }

          let params = {goods: {name: this.goods.name, amount: Number(this.amount), price: this.goods.price, count: this.sales}, orderid:json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'goods-pay', params: params });
          **/
        },
        cb: () => {
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
    errMsg(field) {
      let val = this.users[field] || '';
      let rule = this.users[field +'_rule'];
      if (!rule) {
        return;
      }
      if (val.trim() && rule.error) {
        return rule.message || '输入错误！';
      }
      return '';
    },
    validate(field) {
      let val = this.users[field] || '';
      let rule = this.users[field +'_rule'];
      if (!rule) {
        return;
      }
      if (rule.required) {
        rule.error = !(val.trim());
      }
      if (!rule.error && rule.pattern) {
        rule.error = !(rule.pattern.test(val));
      }
    },
    sendCaptcha() {
      this.validate('mobile');
      if (this.users['mobile_rule'].error) {
        this.Toast('请填写正确的手机号！');
        return;
      }
      // 发送验证码到手机
      this.captcha.loading = true;
      this.doGet({
        url: '/vue/pay/getCaptcha?m='+ this.users.mobile,
        okcb: (json) => {
          this.captcha.issend = true;
          this.captcha.time = 150000;
          this.Toast('验证码发送成功，20分钟内有效！');
        },
        cb: () => {
          this.captcha.loading = false;
        }
      });
    },
    enabledCaptcha() {
      this.captcha.issend = false;
      this.captcha.time = 150000;
    },
    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
    },
    onExchange(code) {
      this.coupons.push(coupon);
    },
    goPay(props) {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || (this.isWeixin && !this.member.openid)) {
        setTimeout(() => {
          this.login();
        }, 100);
      }
      // 校验
      // this.validate('name');
      this.validate('mobile');
      // this.validate('captcha');

      let message = '';
      Object.keys(this.users).forEach(k => {
        if (!message) {
          if (k.endsWith('_rule') && this.users[k].error) {
            message = this.users[k].message || '有字段错误！';
            this.$refs[k.replace('_rule', '')].focus();
          }
        }
      });
      if (message) {
        this.Toast(message);
        return;
      }
      // 
      props.skuEventBus.$emit('sku:buy');
    },
    sorry() {
      this.Toast('暂无后续逻辑~');
    },
    toImage() {
      let el = this.$refs.imageWrapper;
      html2canvas(el, {
        backgroundColor: null,
        allowTaint: true,
        useCORS: true,
        y: 0
      }).then((canvas) => {
        let dataURL = canvas.toDataURL('image/png');
        this.dataURL = dataURL;
        // 打开海报
        this.showPoster = true;
      });
    },
    // 保存图片
    savePoster() {
      const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      save_link.href = this.dataURL;
      save_link.download = this.goods.name;

      const event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      save_link.dispatchEvent(event);

      this.showPoster = false;
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  background-color:#f0f0f0;
  &.is-loading {
    background-color:#fff;
  }
  .van-skeleton {
    height:100vh;
  }
  .van-skeleton__title {
    height:35vh;
  }
}
.goods {
  position:relative;
  padding-bottom: 50px;
  .van-cell:not(:last-child)::after{
    left:0;
  }
  .van-hairline--top-bottom::after{
    border-width:0;
  }
  // .van-hairline--top-bottom.border-after::after{
  //   border-bottom-width:1px;
  // }
  &-bizname {
    .flex();
    color:#222;
    .van-icon {
      padding-right:.35rem;
      .fontsize(1.15rem);
      line-height:1.5;
      color:@bluecolor;
    }
  }
  &-address {
    .flex();
    color:#777;
    .van-icon {
      padding-right:.35rem;
      .fontsize(1.15rem);
      line-height:1.56;
      color:@bluecolor;
    }
  }
  &-swipe {
    text-align:center;
    .van-image{
      height:100%;
    }
    img {
      display: block;
    }
  }
  &-title {
    .fontsize(1.2rem);
    line-height:1.45;
  }
  &-features {
    padding:.25rem 0;
    .fontsize();
    line-height:1.45;
  }
  &-price {
    .fontsize(1.6rem);
    color: @orangecolor;
    small {
      font-size:65%;
      padding-right:.25rem;
    }
  }
  &-market {
    display:inline-block;
    .fontsize(.95rem);
    color:#aaa;
    text-decoration:line-through;
    small {
      padding-right:.05rem;
    }
  }
  &-tags {
    .van-tag {
      margin-right:.25rem;
    }
  }
  &-bar-box {
    // font-weight:bold;
    .border-p(bottom, @bluecolor2);
    /deep/ .van-grid-item__content {
      padding:.65rem .5rem;
    }
    .van-grid-item.active {
      color:@bluecolor;
      /deep/ .van-grid-item__content {
        background-color:#f2faff;
      }
    }
  }
  .van-sticky--fixed &-bar-box {
    margin:0;
    /deep/ .van-grid-item__content {
      .bg-white(.9);
    }
    .van-grid-item.active {
      /deep/ .van-grid-item__content {
        .bg-rgba(242,250,255; .9);
      }
    }
  }
  &-bar {
    .flex-center-v();
    .fontsize(1rem);
    .van-icon {
      padding-right:.3rem;
      .fontsize(1.1rem);
    }
  }
  &-contents {
    h3 {
      margin:0;
      padding:1rem 1rem 0;
    }
    // padding-bottom:5rem;
    &-label {
      .van-divider {
        color:@bluecolor;
        border-color:#f2faff;
      }
    }
  }
  &-recommend {
    padding:0 1rem 1rem;
    .items {
      .flex();
      margin-bottom:.5rem;
      .tits {
        flex-shrink:0;
        margin-right:1rem;
        color:@bluecolor;
      }
      .cons {

      }
    }
  }
  &-info {
    margin:1rem 1rem;
    text-align:justify;
    .bg-black(.06);
    border-radius:1rem;
    .info-item {
      padding:.5rem 0;
      .border-p(bottom, #eee);
      .tits {
        padding:0 .8rem .4rem;
        color:@bluecolor;
      }
      .cons {
        padding:0 .8rem;
        img {
          max-width:100%;
        }
      }
      &:last-child {
        border-bottom:none;
      }
    }
  }
  &-sales {
    text-align:right;
  }
  &-express {
    color: #999;
    padding: 5px 15px;
    .text-right {
      .fontsize(1rem);
    }
    .prices {
      .flex();
      justify-content:space-between;
    }
  }
  &-coupon {
    .fontsize();
    .van-tag {
      .fontsize();
      line-height:1;
      i, span {
        display:inline-block;
        vertical-align:middle;
      }
    }
    .van-icon {
      margin-right:.25rem;
      .fontsize(1.15rem);
    }
  }
  &-cell-group {
    &.pricelist {
      margin-top:1rem;
      .shadow_black(0 1px 0, .05);
      .van-cell {
        align-items:center;
      }
    }
    &.contents {
      margin-top:1rem;
      .shadow_black(0 -1px 0, .005);
    }
    &.border-after {
      .shadow_black(0 1px 0, .05);
    }
    &.biz {
      .shadow_black(0 1px 0, .05);
    }
    .van-cell__value {
      color: #999;
    }
  }
  &-headicon-box {
    position:absolute;
    top:0rem;
    z-index: 999;
    .flex-center();
    padding:.5rem 0;
    width:100%;
    .fixedapp();
  }
  &-headicon {
    .flex-center();
    width:2rem;
    height:2rem;
    color:#fff;
    .bg-black(.5);
    border-radius:50%;
    &.back {
      margin-left:1rem;
      margin-right:auto;
    }
    &.cart {
      margin-right:1rem;
      .van-info {
        top:-.8rem;
        right:-.3rem;
        border-color:transparent;
      }
    }
    &.share {
      display:none;
      margin-right:1rem;
    }
    &:hover{
      color:@bluecolor;
    }
    &.tags {
      .flex-center();
      width:7rem;
      height:2rem;
      line-height:2rem;
      color:#fff;
      background-color:@bluecolor;
      border-radius:.35rem 0 0 .35rem;
      .shadow_blur_black(10px, .76);
      cursor:pointer;
      .van-icon {
        margin-right:.5rem;
      }
    }
  }
  .van-sticky--fixed &-headicon-box {
    .bg-black(.45);
    .goods-headicon {
      .bg-black(.85);
      &.tags {
        background-color:@bluecolor;
      }
    }
  }
  /deep/ .sticky-title .van-sticky--fixed {
    left:50%;
    transform:translateX(calc(-50% - 1.75rem));
    width:calc(100% - 11rem);
    max-width:calc(@appwidth - 11rem);
  }
  /deep/ .sticky-goods-bar .van-sticky--fixed {
    .fixedapp();
    width:100%;
  }
  .van-sticky--fixed &-title {
    color:#fff;
    .fontsize(1.15rem);
    line-height:2.5;
    text-shadow:1px 1px 1px #000;
    .text-more();
  }
  &-content {
    padding:1rem .8rem;
    .fontsize(1rem);
    line-height:1.75;
    /deep/ img {
      max-width:100%;
    }
    &.icons {
      .flex-center-v();
      .van-icon {
        margin-right:.5rem;
      }
    }
  }
  
  /deep/ .van-goods-action {
    .fixedapp();
    z-index:2;
    width:100%;
    box-sizing:border-box;
    .border-p(top, #eee, 1px);
    .van-goods-action-icon {
      padding:0 1rem;
      .fontsize(1rem);
      &:first-child {
        .border-p(right, #eee, 1px);
      }
    }
    .van-goods-action-button {
      margin-right:0;
      height:50px;
      .fontsize(1.2rem);
      border-radius:0;
    }
  }
  /deep/ .van-coupon-list__list {
    padding-bottom:50px;
  }
}
.goods-detail /deep/.van-cell {
  .fontsize();
}
.goods-detail /deep/ .van-sku-container {
  .fontsize();
  .van-popup__close-icon {
    top:-1.8rem;
    right:0;
    .fontsize(1.8rem);
    color:#fff;
  }
  .van-sku-header__img-wrap.cover .van-image {
    display: block;
    height: 100%;
  }
  .van-sku-header__goods-info {
    justify-content:flex-start;
    padding: .5rem 1rem;
    min-height:30px;
  }
  .van-sku-price-box {
    .flex-center-v();
    .van-sku__goods-title {
      flex-grow:0;
      .fontsize(1.2rem);
      .text-more();
    }
  }
  .van-sku-header-item {
    .fontsize();
    .van-sku__detail {
      font-size:.9rem;
      line-height:1.45;
      overflow:hidden; word-break:break-all; text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:4;
    }
  }
  .van-sku__skus {
    .flex-center-h();
    flex-wrap:wrap;
    padding:.5rem .5rem;
    .bg-black(.02);
    .van-tag {
      .flex-center-v();
      margin:.15rem .35rem;
      padding:.4rem 1rem;
      .text-more();
      .fontsize(1.1rem);
      cursor:pointer;
      .van-icon {
        margin-right:.2rem;
        .fontsize();
      }
      &::after {
        display:none;
      }
      &.van-tag--primary {
        border:1px @bluecolor solid;
      }
      &.van-tag--default {
        border:1px #969799 solid;
      }
    }
  }
  .van-sku__steppers {
    .flex();
    padding:.2rem .5rem;
    justify-content:space-between;
    align-items:center;
    .bg-black(.02);
    .van-sku__goods-price {
      white-space:nowrap;
      color:@orangecolor;
      .van-sku__price-num {
        .fontsize(1.6rem);
        .van-sku__price-symbol {
          .fontsize();
        }
      }
    }
    .van-stepper__input {
      margin:0;
      background-color:#fff;
      border:1px #eee solid;
    }
  }
  .van-sku-messages {
    .van-cell-group__title {
      padding:.5rem 1rem;
    }
    .van-cell {
      padding:.35rem 1.2rem;
    }
    .van-button--small {
      height:26px;
      .fontsize();
      line-height:26px;
    }
  }
  .van-field__label {
    width:4.65rem;
  }
  .van-field__error-message {
    font-size:.85rem;
    color:@bluecolor;
  }
  .van-notice-bar--wrapable {
    padding:.2rem .5rem;
  }
  .van-notice-bar__content {
    font-size:.85rem;
    line-height:1.4;
    color:#666;
  }
  .van-sku-actions {
    align-items:center;
    .van-sku-subtotal {
      flex-shrink:0;
      margin-right:1.5rem;
      .prices {
        .fontsize(1.6rem);
        color:@bluecolor;
      }
    }
    .van-button__text {
      .fontsize(1.2rem);
      letter-spacing:.1rem;
    }
  }
}
.poster-dialog {
  overflow:visible;
  .van-dialog__content {
    overflow:visible;
  }
  .poster-close {
    position:absolute;
    top:-1.6rem;
    right:-.15rem;
    z-index:99;
    .fontsize(1.2rem);
    color:#fff;
  }
  .poster-btns {
    position:absolute;
    bottom:-2.5rem;
    .flex-center-h();
    width:100%;
    .van-button {
      margin:0 1rem;
      height:26px;
    }
  }
}
.poster {
  position:absolute;
  top:0;
  left:-1000%;
  // padding-bottom:8rem;
  max-width:400px;
  border-radius:.5rem;
  overflow:hidden;
  &-head {
    .flex-between();
    padding:.5rem;
    font-size:.9rem;
    background-color:#f0f0f0;
  }
  &-note {
    .text-more();
  }
  &-author {
    flex-shrink:0;
  }
  &-body {
    position:relative;
  }
  &-img{
    height:100%;
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
  }
  &-footer {
    .flex();
    padding:.6rem 0 0 .6rem;
  }
  &-infos {
    padding-right:.4rem;
  }
  &-title {
    padding-bottom:.25rem;
    .fontsize(1.15rem);
  }
  &-features {
    font-size:.9rem;
    color:#777;
  }
  &-price {
    .fontsize(1.2rem);
    color:@bluecolor;
    small {
      font-size:50%;
    }
  }
  &-market {
    display:inline-block;
    .fontsize(1.1rem);
    color:#aaa;
    text-decoration:line-through;
    small {
      font-size:50%;
    }
  }
  &-qrcode {
    position:relative;
    margin-left:auto;
    align-self:flex-end;
    .logo {
      position:absolute;
      top:50%;
      left:50%;
      height:1.5rem;
      transform:translate(-50%, -50%);
      background-color:#fff;
      border-radius:.5rem;
      img{
        height:100%;
      }
    }
  }
}
.real_pic {
  width:100%;
}
</style>